// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d7e77aa9","238":"86a4dcb7","239":"782f6ec5","488":"ddce9e74","732":"ee1c57c0"}[chunkId] + ".chunk.js";
};